import { render, staticRenderFns } from "./pcb.vue?vue&type=template&id=e0b37208&scoped=true"
import script from "./pcb.vue?vue&type=script&lang=js"
export * from "./pcb.vue?vue&type=script&lang=js"
import style0 from "./pcb.vue?vue&type=style&index=0&id=e0b37208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b37208",
  null
  
)

export default component.exports